import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import {
  decreaseQuantity,
  removeFromBasket,
} from '../../../store/slices/basketSlice';
import { getStoredBasket, saveStoredBasket } from '../libs/basketStorage';

export const useDecreaseFromBasket = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const basketItems = useSelector((state: RootState) => state.basket.items);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      product_id,
      cartKey,
      remove_all,
    }: {
      product_id: number;
      cartKey?: string;
      remove_all?: boolean;
    }) => {
      const currentBasket = basketItems.length ? basketItems : getStoredBasket();
      const targetCartKey = cartKey ?? String(product_id);
      const basketItem = currentBasket.find(item => item.cartKey === targetCartKey);

      if (!basketItem) {
        return { success: true };
      }

      const nextBasket = remove_all || basketItem.quantity <= 1
        ? currentBasket.filter(item => item.cartKey !== targetCartKey)
        : currentBasket.map(item =>
            item.cartKey === targetCartKey
              ? { ...item, quantity: item.quantity - 1 }
              : item
          );

      saveStoredBasket(nextBasket);

      if (remove_all || basketItem.quantity <= 1) {
        dispatch(removeFromBasket(targetCartKey));
      } else {
        dispatch(decreaseQuantity(targetCartKey));
      }

      return { success: true };
    },
    onSuccess: () => {
      queryClient.setQueryData(['basket'], { basket: getStoredBasket() });
      queryClient.invalidateQueries({ queryKey: ['basket'] });
    },
  });
  return {
    decreaseFromBasket: mutateAsync,
    isPending,
  };
};
